import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { CcApprovalLevel } from "server/models"
import { StoreType, addModal } from "client/store"
import {
    Link,
    TableColumn,
} from "client/components"

import Edit from "../edit"

const Columns = (
    editAccess: boolean,
    module: number,
) => {
    const groupList = useSelector((state: StoreType) => state.projectGroup.groupList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
        },
        {
            field: "name",
            header: lang.name,
            cellMinWidth: "100px",
            formatter: (level: CcApprovalLevel) => {
                if (!editAccess) return level.name
                return (
                    <Link
                        href="/#"
                        onClick={() => dispatch(addModal({
                            key: "editApprovalLevel",
                            content: <Edit levelId={level.id} module={module} />,
                        }))}
                    >
                        {level.name}
                    </Link>
                )
            },
        },
        {
            field: "group",
            header: lang.group,
            cellMinWidth: "100px",
            formatter: (level: CcApprovalLevel) => {
                if (!groupList) return null
                const group = groupList[level.groupId]
                return group && group.name
            },
        },
    ]

    if (editAccess) {
        columns.unshift({
            field: "sort",
            centerAlign: true,
        })
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
